<template>
  <div class="contract-page">
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <KTCodePreview v-bind:title="''">
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <div class="wizard-nav-bg">
            <b-col
              class="py-2 mb-1"
              cols="12"
              style="border-bottom: 0.5px solid #e7e7e7"
            >
              <HeaderDetail
                ref="HeaderDetailRef"
                typeHeader="order-list"
                :userInfor="userInfor"
                :disable="true"
                :apiParams="apiParams"
                :param="selectedOrders"
                :type="type"
                :isExporting="isExporting"
                v-on:update-company-component="updateCompanyComponent"
                v-on:set-mode="onSetMode"
                v-on:export-excel="onExportExcel"
              />
            </b-col>
          </div>
          <div
            class="wizard wizard-4"
            id="kt_wizard_v4_order"
            data-wizard-state="step-first"
            data-wizard-clickable="true"
          >
            <b-col cols="12" class="py-8 custom-card-body">
              <!-- ===== Dashboard nhanh — click 1 ô để lọc theo trạng thái HĐ ===== -->
              <div class="ctr-stats">
                <div
                  v-for="s in statsCards"
                  :key="s.key"
                  class="ctr-stat-card"
                  :class="{ active: isStatActive(s.status) }"
                  :style="{
                    '--ctr-accent': s.color,
                    '--ctr-accent-soft': s.bg,
                  }"
                  @click="onSelectStat(s.status)"
                >
                  <span class="ctr-stat-num">
                    {{
                      statsCounts[s.key] !== undefined
                        ? statsCounts[s.key]
                        : '—'
                    }}
                  </span>
                  <span class="ctr-stat-label">{{ s.label }}</span>
                </div>
              </div>
              <div class="ctr-divider"></div>
              <b-row class="mb-4">
                <b-col cols="3">
                  <div class="date-style">
                    <b-input-group>
                      <date-picker
                        placeholder="Từ"
                        class="form-control form-control-sm"
                        :config="dpConfigs.date"
                        v-model="apiParams.fromDate"
                      ></date-picker>
                    </b-input-group>
                    <span class="ml-1 mr-1"></span>
                    <b-input-group>
                      <date-picker
                        placeholder="Đến"
                        class="form-control form-control-sm"
                        :config="dpConfigs.date"
                        v-model="apiParams.toDate"
                      ></date-picker>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col cols="3" v-if="checkPermissions(['STORE_VIEW_ALL'])">
                  <BDropdownCustom
                    v-model="apiParams.storeIds"
                    :options="optionStores"
                    :placeholder="'cửa hàng'"
                    :searchable="true"
                    :matchKey="['name', 'shortName']"
                    :limit="5"
                  />
                </b-col>
                <b-col cols="3" v-if="checkPermissions(['CONTRACT_VIEW'])">
                  <Autosuggest
                    :model="apiParams.employeeName"
                    :suggestions="optionsEmployee"
                    :suggestionName="'fullName'"
                    :placeholder="'nhân viên CSKH'"
                    :limit="100"
                    @select="onSelected($event, 'Employee')"
                    @change="onInputed($event, 'Employee')"
                  >
                    <template #custom="{ suggestion }">
                      {{ suggestion.item.fullName }}
                    </template>
                  </Autosuggest>
                </b-col>
                <b-col cols="3">
                  <BDropdownCustom
                    v-model="apiParams.contractStatus"
                    :options="contractStatusOptions"
                    :placeholder="'trạng thái hợp đồng'"
                    :searchable="true"
                    :textProp="'text'"
                    :valueProp="'value'"
                    :matchKey="['text']"
                    :limit="9"
                  />
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col cols="3">
                  <b-input
                    placeholder="Nhập mã hợp đồng"
                    v-model="apiParams.id"
                    size="sm"
                    autocomplete="off"
                    v-focus
                  ></b-input>
                </b-col>
                <b-col cols="3">
                  <Autosuggest
                    :model="apiParams.customerPhoneSearch"
                    :suggestions="optionsCustomerPhone"
                    :suggestionName="'phoneNumber'"
                    :placeholder="'Tên / SĐT khách hàng (≥4 ký tự)'"
                    :limit="10"
                    @select="onSelectedCustomerPhone"
                    @change="onChangeCustomerPhone"
                  >
                    <template #custom="{ suggestion }">
                      <div class="d-flex flex-column">
                        <span
                          class="text-primary mb-1"
                          v-if="suggestion.item.phoneNumber"
                          >({{ suggestion.item.phoneNumber }})</span
                        >
                        <span>{{ suggestion.item.fullName }}</span>
                      </div>
                    </template>
                  </Autosuggest>
                </b-col>
                <!-- <b-col>
                  <b-input
                    placeholder="Nhập ghi chú CSKH"
                    v-model="apiParams.saleNote"
                    autocomplete="off"
                    size="sm"
                  />
                </b-col>
                <b-col>
                  <treeselect
                    :options="optionCancelStatus"
                    :multiple="false"
                    placeholder="Nhập lý do huỷ"
                    noResultsText="Không có kết quả"
                    :match-keys="['label', 'custom']"
                    :value="apiParams.cancelStatus"
                    v-model="apiParams.cancelStatus"
                    openDirection="bottom"
                  >
                    <label
                      slot="option-label"
                      slot-scope="{ node, labelClassName }"
                      :class="labelClassName"
                    >
                      <span :title="node.label"> {{ node.label }}</span>
                    </label>
                  </treeselect>
                </b-col> -->
                <b-col cols="3">
                  <b-input
                    placeholder="Nhập tên sản phẩm"
                    v-model="apiParams.productSearch"
                    autocomplete="off"
                    size="sm"
                  />
                </b-col>
                <b-col cols="3">
                  <b-input
                    placeholder="Nhập số khung / số máy"
                    v-model="apiParams.chassisEngineSearch"
                    autocomplete="off"
                    size="sm"
                  />
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col cols="3">
                  <b-input
                    placeholder="Nhập số seri"
                    v-model="apiParams.serialSearch"
                    autocomplete="off"
                    size="sm"
                  />
                </b-col>
                <b-col cols="4" class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="apiParams.missingPaymentCode"
                    switch
                  >
                    Chỉ HĐ chưa nhập mã tham chiếu
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button-group size="sm">
                    <b-button
                      style="width: 70px"
                      class="font-weight-bolder"
                      variant="primary"
                      @click="onFilter"
                      ><i class="fas fa-search text-white fa-lg"></i
                      >Lọc</b-button
                    >
                  </b-button-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <ContractListTable
                    :paramSearch="paramSearch"
                    ref="orderTableRef"
                    v-on:onCheckBoxOrders="onCheckBoxOrders"
                    v-on:refresh="loadStats"
                  />
                </b-col>
              </b-row>
            </b-col>
          </div>
        </b-card>
      </template>
    </KTCodePreview>
    <!-- <template v-if="checkPermissions(['ORDER_UPDATE'])">
      <OrderChangeCommon
        :mode="mode"
        :userInfor="userInfor"
        v-on:refresh="onRefreshOrder"
      />
    </template>
    <OrderImportExcel v-on:refresh="onRefreshOrder" /> -->
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodeTab.vue';
import { mapGetters } from 'vuex';
import Loader from '@/view/content/Loader.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { checkPermissions } from '@/utils/saveDataToLocal';
import { removeAccents, makeToastFaile } from '@/utils/common';
import fileDownload from '@/utils/file-download';
import { ContractService } from '@/core/services/contract.service';
//   import { removeAccents, makeToastFaile } from '@/utils/common';
// import OrderChangeCommon from '@/view/components/order/OrderChangeCommon.vue';
// import OrderImportExcel from '@/view/components/order/OrderImportExcel.vue';
import ContractListTable from '@/view/components/contracts/List.vue';
import HeaderDetail from '@/view/components/contracts/HeaderDetail.vue';
import {
  CONTRACT_STATUS,
  CONTRACT_STATUS_LABEL,
  CONTRACT_STATUS_FILTER_OPTIONS,
} from '@/core/constants/contract';

// Dashboard stats cards — 1 ô "Tổng" + 1 ô / trạng thái HĐ thực tế.
// Click ô → set apiParams.contractStatus rồi reload danh sách + stats (pattern
// theo trang Đề nghị tạo HĐ — contract-request/List.vue).
// Màu ô đồng bộ palette badge bảng (CONTRACT_STATUS_VARIANT): Chờ ký=cam,
// Đã ký/Đã đặt cọc/Đã phân bổ=xanh dương, Đã tạo hóa đơn=primary, Đã hủy=đỏ, Tổng=xám đậm.
const CONTRACT_STATS_CARDS = [
  { key: 'all', label: 'Tổng', status: null, bg: '#ECF0F3', color: '#464E5F' },
  {
    key: 'pendingDeposit',
    label: 'Chờ cọc',
    status: CONTRACT_STATUS.PENDING_DEPOSIT,
    bg: '#FFF4DE',
    color: '#FFA800',
  },
  {
    key: 'deposited',
    label: 'Đã đặt cọc',
    status: CONTRACT_STATUS.DEPOSITED,
    bg: '#C9F7F5',
    color: '#1BC5BD',
  },
  {
    key: 'allocated',
    label: 'Đã phân bổ xe',
    status: CONTRACT_STATUS.ALLOCATED,
    bg: '#EEE5FF',
    color: '#8950FC',
  },
  {
    key: 'invoiced',
    label: 'Đã tạo hóa đơn',
    status: CONTRACT_STATUS.INVOICED,
    bg: '#E8FFF3',
    color: '#1B7E4E',
  },
  {
    key: 'cancelled',
    label: 'Đã hủy',
    status: CONTRACT_STATUS.CANCELLED,
    bg: '#FFE2E5',
    color: '#F64E60',
  },
];

import SaveDataUtil from '@/utils/saveDataToLocal';
import {
  cloneDeep,
  debounce,
  keyBy,
  entries,
  isEmpty,
  isNil,
  omitBy,
  omit,
} from 'lodash';
import jQuery from 'jquery';
import moment from 'moment';
import {
  DEFAULT_COMANY_ID,
  ORDER_TYPE,
  TIME_TRIGGER,
  ORDER_STATUS,
  ORDER_CANCEL_STATUS,
  ORDER_CANCEL_STATUS_CR,
  ORDER_CANCEL_STATUS_SHOP,
  ORDER_CANCEL_STATUS_DP,
  CRITERIA,
  LOAN_STATUS,
  CUSTOMER_TYPE,
  DEPARTMENT,
  CONSTANT_PARTNER_PAYMENT,
} from '@/utils/constants';
import { JOB_TITLE_ORDER } from '@/utils/enum';
//   import { CRITERIA_FILTER_BILL, JOB_TITLE_ORDER } from '@/utils/enum';
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';
import decounce from 'debounce';
import timeUtils from '@/utils/date';
// import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import BDropdownCustom from '../../base/bootstrap/BDropdownCustom.vue';
export default {
  data() {
    return {
      wizard: null,
      currentWizard: 1,
      size: 10,
      page: this.$route.query.page || 1,
      dpConfigs: null,
      // Khoá nút "Xuất Excel" trong lúc chờ file — BE stream không kèm Content-Length nên
      // không có % tiến độ, chỉ spinner. Không khoá thì user bấm nhiều lần, mỗi lần là một
      // lượt quét toàn bộ kết quả lọc ở BE.
      isExporting: false,
      apiParams: {
        companyId: DEFAULT_COMANY_ID,
        orderSourceId: null,
        orderSourceName: '',
        // FE-005 — filter theo CONTRACT_STATUS (state machine 9 bước).
        contractStatus: [],
        orderType: null,
        fromDate: moment().subtract(2, 'months').format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY'),
        storeIds: [],
        cancelStatus: null,
        criteriaIds: [],
        customerNote: null,
        customerSearch: null,
        id: null,
        employeeId: null,
        employeeName: '',
        saleNote: null,
        productSearch: null,
        chassisEngineSearch: null,
        serialSearch: null,
        missingPaymentCode: false,
        tabName: 'all',
        checkDate: null,
        customerType: null,
        departmentId: null,
        customerNameSearch: null,
        customerPhoneSearch: null,
        partnerPaymentStatus: null,
      },
      optionsCustomerType: [],
      optionStatus: [],
      // FE-005 — options dropdown filter trạng thái HĐ: chỉ các state thực tế đang dùng
      // (pendingSignature → signed → deposited → allocated + cancelled).
      contractStatusOptions: CONTRACT_STATUS_FILTER_OPTIONS,
      optionCancelStatus: null,
      filteredOrderSources: [],
      optionTypes: [],
      companies: [],
      optionCriterias: [],
      optionsDepartments: [],
      optionOrigin: {
        orderSources: [],
        employees: [],
        stores: [],
      },
      optionStores: [],
      filteredEmployees: [],
      selectedOrders: [],
      mode: '',
      paramSearch: null,
      settings: [],
      fromUrl: false,
      optionLoanStatus: [],
      userInfor: null,
      filteredOptionsCustomerPhone: [],
      isSearchingCustomerPhone: false,
      paramsUrl: [],
      type: null,
      // Dashboard stats — config (constant) + counts theo từng ô.
      statsCards: CONTRACT_STATS_CARDS,
      statsCounts: {
        all: undefined,
        pendingDeposit: undefined,
        deposited: undefined,
        allocated: undefined,
        invoiced: undefined,
        cancelled: undefined,
      },
    };
  },
  components: {
    KTCodePreview,
    Loader,
    ContractListTable,
    HeaderDetail,
    // Treeselect,
    // OrderChangeCommon,
    // OrderImportExcel,
    Autosuggest,
    BDropdownCustom,
  },
  created() {
    this.fetchStores();
    this.initialConstant();
    this.getParamsFromUrl();
    this.fetchEmployees();
    //   this.initSetting();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hợp đồng', route: 'contracts' },
      { title: 'Danh sách hợp đồng mua bán' },
    ]);

    const query = this.$route.query || null;
    const tabName = query ? query.tabName : '';
    if (tabName) {
      const settings = keyBy(this.settings, 'tableName');
      const settingItem = settings[tabName] || null;
      this.currentWizard = settingItem ? settingItem.currentWizard : 1;
    }

    this.wizard = new KTWizard('kt_wizard_v4_order', {
      startStep: this.currentWizard,
      clickableSteps: true,
    });

    this.$nextTick(function () {
      this.wizard.on('change', this.onChangeTab);
    });

    window.addEventListener('keyup', this.onFilterKeyEnter);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.onFilterKeyEnter);
  },
  methods: {
    checkPermissions,
    /**
     * Xuất Excel danh sách HĐ theo ĐÚNG filter đang áp.
     *
     * Dùng `getParamFilters()` — chính hàm mà bảng bên dưới dùng để nạp dữ liệu. Đừng dựng
     * bộ param riêng ở đây: lệch một field là file xuất ra khác với những gì người dùng
     * đang nhìn, và họ sẽ không có cách nào biết.
     */
    async onExportExcel() {
      if (this.isExporting) return;
      this.isExporting = true;

      try {
        const response = await ContractService.exportExcel(
          this.getParamFilters(),
        );
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
      } catch (error) {
        // Lỗi cũng về dạng blob (do responseType: 'blob'), phải đọc qua .text() rồi mới
        // parse được JSON — bỏ bước này thì toast hiện '[object Blob]'.
        let message = 'Xuất Excel thất bại. Vui lòng thử lại.';
        try {
          const raw = await error?.response?.data?.text?.();
          if (raw) message = JSON.parse(raw).message || message;
        } catch (parseError) {
          // Không parse được (lỗi mạng, hoặc stream đứt giữa chừng nên body không phải
          // JSON) → giữ message mặc định, đừng che mất lỗi gốc.
          message = error?.message || message;
        }
        makeToastFaile(message);
      } finally {
        this.isExporting = false;
      }
    },
    onPreventEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        return false;
      }
    },
    onFilterKeyEnter(event) {
      if (event.key === 'Enter') {
        const isShown = jQuery('.modal').hasClass('show');
        if (!isShown) this.onFilter();
      }
    },
    initialConstant() {
      const userInfor = this.getEmployeeFromLocal();
      this.userInfor = userInfor;
      this.dpConfigs = timeUtils.DP_CONFIG;
      this.optionsCustomerType = cloneDeep(CUSTOMER_TYPE);
      this.optionStatus = cloneDeep(
        ORDER_STATUS.filter((item) => item.value && !item.checked),
      );

      this.optionTypes = cloneDeep(ORDER_TYPE).reduce((result, element) => {
        if (element.id !== null) {
          result.push({
            id: element.id,
            label: element.name,
            custom: removeAccents(element.name),
            customLabel: element.name,
          });
        }
        return result;
      }, []);

      this.optionPaymentStatus = cloneDeep(CONSTANT_PARTNER_PAYMENT).reduce(
        (result, element) => {
          if (element.id !== null) {
            result.push({
              id: element.id,
              label: element.name,
              custom: removeAccents(element.name),
              customLabel: element.name,
            });
          }
          return result;
        },
        [],
      );
      this.optionCriterias = cloneDeep(CRITERIA);
      this.optionsDepartments = cloneDeep(DEPARTMENT);
      this.optionLoanStatus = cloneDeep(
        LOAN_STATUS.filter((item) => !item.checked),
      );

      let cancelStatus = [];
      const jobTitleId = userInfor.jobTitleId;
      if (this.checkJobTitle.isCR(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_CR;
      } else if (this.checkJobTitle.isShop(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_SHOP;
      } else if (this.checkJobTitle.isDP(jobTitleId)) {
        cancelStatus = ORDER_CANCEL_STATUS_DP;
      } else {
        cancelStatus = ORDER_CANCEL_STATUS;
      }
      this.optionCancelStatus = cloneDeep(cancelStatus).reduce(
        (result, element) => {
          if (element.value !== null) {
            result.push({
              id: element.value,
              label: element.text,
              custom: removeAccents(element.text),
              customLabel: element.text,
            });
          }
          return result;
        },
        [],
      );
    },
    //   initSetting() {
    //     const userInfor = this.userInfor;
    //     this.settings = [
    //       {
    //         tableName: 'all',
    //         currentWizard: 1,
    //       },
    //     ];
    //     this.getTabJobTitle(userInfor);
    //   },
    //   getTabJobTitle(userInfor) {
    //     if (!userInfor.jobTitleId) {
    //       makeToastFaile('Nhân viên chưa được gắn kí chức vụ');
    //       return;
    //     }

    //     if (JOB_TITLE_ORDER.CR.includes(userInfor.jobTitleId)) {
    //       this.settings = this.settings.concat([
    //         {
    //           tableName: 'online',
    //           currentWizard: 2,
    //         },
    //         {
    //           tableName: 'installment',
    //           currentWizard: 3,
    //           params: {
    //             orderSourceId: 756132,
    //             orderSourceName: 'Order Online',
    //           },
    //           mutiselects: {
    //             criterias: {
    //               values: [CRITERIA_FILTER_BILL.HAVE_INSTALLMENT],
    //               prop: 'id',
    //             },
    //           },
    //         },
    //         {
    //           tableName: 'shinhan',
    //           currentWizard: 4,
    //           params: {
    //             orderSourceId: 756132,
    //             orderSourceName: 'Order Online',
    //           },
    //           mutiselects: {
    //             criterias: {
    //               values: [CRITERIA_FILTER_BILL.HAVE_INSTALLMENT],
    //               prop: 'id',
    //             },
    //             stores: {
    //               values: [],
    //               prop: 'id',
    //             },
    //           },
    //         },
    //       ]);
    //     } else {
    //       const storeId = userInfor.storeId || null;
    //       let mutiselects = {};
    //       if (storeId) {
    //         mutiselects = {
    //           stores: {
    //             values: [storeId],
    //             prop: 'id',
    //           },
    //         };
    //       }
    //       this.settings.push({
    //         tableName: 'store',
    //         currentWizard: 2,
    //         mutiselects: mutiselects,
    //       });
    //     }
    //   },
    getEmployeeFromLocal() {
      const userFromLocal = SaveDataUtil.getData('employee_info');
      if (userFromLocal) {
        const tmpInfo = JSON.parse(userFromLocal);
        return tmpInfo;
      }
    },
    validateState(name) {
      if (!name) return null;
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onChangeTab(item) {
      this.optionCriterias = cloneDeep(CRITERIA);
      this.apiParams.orderSourceId = null;
      this.apiParams.orderSourceName = null;
      this.currentWizard = item.currentStep;

      const setting = this.settings.find((s) => {
        return s.currentWizard === (item ? item.currentStep : 1);
      });

      if (setting) {
        this.$router.replace({
          query: Object.assign({}, this.$route.query, {
            tabName: setting.tableName,
          }),
        });
        this.apiParams.tabName = setting.tableName;

        if (setting.params) {
          for (const [key, value] of entries(setting.params)) {
            this.apiParams[key] = value;
          }
        }

        if (setting.mutiselects) {
          for (const [key] of entries(setting.mutiselects)) {
            const values = setting.mutiselects[key]
              ? setting.mutiselects[key].values
              : [];
            const prop = setting.mutiselects[key]
              ? setting.mutiselects[key].prop
              : [];

            const keyName = key.charAt(0).toUpperCase() + key.slice(1);
            const keyOption = `option${keyName}`;
            const keyId = `${key.slice(0, -1)}Ids`;
            const items = this[`option${keyName}`];

            values.map((id) => {
              const index = items.findIndex((x) => x[prop] === id);
              if (index > -1) {
                this[keyOption][index].checked = true;
                const existId = this.apiParams[keyId].findIndex(
                  (item) => item[prop] === id,
                );
                if (existId < 0) {
                  this.apiParams[keyId].push(items[index]);
                }
              }
            });
          }
        }
      }

      this.fetchDataTable();
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    },
    getParamsFromUrl() {
      const query = this.$route.query || null;

      if (!isEmpty(query)) {
        const criteriaIds = query.searchCriteria
          ? [].concat(query.searchCriteria)
          : [];

        const criteriaCheckeds = [];
        this.optionCriterias.map((item) => {
          if (criteriaIds.includes(String(item.id))) {
            criteriaCheckeds.push(item);
          }
        });

        const storeIds = query.storeId ? [].concat(query.storeId) : [];
        const storeCheckeds = [];

        this.optionStores.map((item) => {
          if (storeIds.includes(String(item.id))) {
            storeCheckeds.push(item);
          }
        });
        this.apiParams = {
          ...this.apiParams,
          companyId: query.companyId
            ? Number(query.companyId)
            : DEFAULT_COMANY_ID,
          storeIds: storeCheckeds,
          criteriaIds: criteriaCheckeds,
        };
        this.fromUrl = true;
      }
    },
    setFillter() {
      const param = this.getParamFilters();

      this.fromUrl = false;
      return param;
    },
    onFilter() {
      this.onChangeUrl();
      this.fetchDataTable();
      this.loadStats();
    },
    // ===== Dashboard stats =====
    // Ô "Tổng" active khi không lọc trạng thái; ô khác active khi status nằm trong
    // apiParams.contractStatus (mảng { value, text }).
    isStatActive(status) {
      const selected = (this.apiParams.contractStatus || []).map(
        (item) => item.value,
      );
      if (!status) return selected.length === 0;
      return selected.includes(status);
    },
    // Click ô stats → set filter trạng thái = trạng thái ô đó (ô "Tổng" = bỏ lọc)
    // rồi reload danh sách + stats. BDropdownCustom filter trạng thái HĐ tự phản ánh
    // vì cùng bind apiParams.contractStatus.
    onSelectStat(status) {
      this.apiParams.contractStatus = status
        ? [{ value: status, text: CONTRACT_STATUS_LABEL[status] || status }]
        : [];
      this.page = 1;
      if (this.$route.query) this.$route.query.page = 1;
      this.onFilter();
    },
    // Load 7 stats song song — mỗi call dùng pageSize=1 chỉ để đọc total từ
    // response.data.data.paginations.total. Stats chỉ áp filter cửa hàng + khoảng
    // ngày (Từ/Đến) hiện tại — KHÔNG áp các filter text-search → dashboard luôn là
    // tổng quan theo cửa hàng (nhất quán với trang Đề nghị tạo HĐ).
    loadStats() {
      const stores = (this.apiParams.storeIds || []).map((store) => store.id);
      const baseParams = {
        page: 1,
        pageSize: 1,
        storeIds: stores,
        fromDate: this.apiParams.fromDate
          ? moment(this.apiParams.fromDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        toDate: this.apiParams.toDate
          ? moment(this.apiParams.toDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
      };
      const calls = this.statsCards.map((card) => {
        const params = {
          ...baseParams,
          contractStatus: card.status ? [card.status] : [],
        };
        return ApiService.query('contract', { params })
          .then((response) => {
            const data = response && response.data && response.data.data;
            const total =
              data &&
              data.paginations &&
              typeof data.paginations.total === 'number'
                ? data.paginations.total
                : Array.isArray(data && data.data)
                  ? data.data.length
                  : 0;
            this.$set(this.statsCounts, card.key, total);
          })
          .catch(() => {
            this.$set(this.statsCounts, card.key, 0);
          });
      });
      return Promise.all(calls);
    },
    onChangeUrl() {
      this.$route.query.page = 1;
      let param = this.setFillter();

      param = omit(param, ['page', 'pageSize']);

      this.$router.push({
        name: 'list',
        query: omitBy(param, isNil),
      });
    },
    fetchDataTable() {
      this.paramSearch = { ...this.getParamFilters() };
    },
    debounceInput: debounce((textInput, fn) => {
      fn(textInput);
    }, TIME_TRIGGER),
    getParamFilters() {
      // get danh sách cửa hàng
      const stores = this.apiParams.storeIds.map((store) => store.id);

      //get danh sách đặc điểm filter
      const criterias = this.apiParams.criteriaIds.map((item) =>
        Number(item.id),
      );
      // FE-005 — danh sách CONTRACT_STATUS (string) đã chọn.
      const contractStatus = this.apiParams.contractStatus.map(
        (item) => item.value,
      );

      const searchLoanStatus = this.getValuesMultiSelect(
        this.optionLoanStatus,
        'value',
      );

      //get danh sách lý do filter
      const cancelStatus = this.apiParams.cancelStatus
        ? Number(this.apiParams.cancelStatus)
        : null;
      //get tab name
      // const tabName = this.fromUrl
      //   ? this.$route.query.tabName || 'all'
      //   : this.apiParams.tabName;

      return {
        page: this.page,
        pageSize: this.size,
        id: this.apiParams.id,
        type: this.apiParams.orderType,
        customerNote: this.apiParams.customerNote,
        saleNote: this.apiParams.saleNote,
        cancelStatus: cancelStatus,
        createdBy: this.apiParams.employeeId,
        searchProduct: this.apiParams.productSearch,
        // companyId: this.apiParams.companyId,
        orderSourceId: this.apiParams.orderSourceId,
        storeIds: stores,
        contractStatus: contractStatus,
        searchCriteria: criterias,
        searchCustomer:
          (this.apiParams.customerPhoneSearch || '').trim().length >= 4
            ? this.apiParams.customerPhoneSearch.trim()
            : null,
        fromDate: this.apiParams.fromDate
          ? moment(this.apiParams.fromDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        toDate: this.apiParams.toDate
          ? moment(this.apiParams.toDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        searchChassisEngine: this.apiParams.chassisEngineSearch,
        searchSerial: this.apiParams.serialSearch,
        missingPaymentCode: this.apiParams.missingPaymentCode || undefined,
        // tabName: tabName,
        searchLoanStatus: searchLoanStatus,
        checkDate: this.apiParams.checkDate
          ? moment(this.apiParams.checkDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : null,
        customerType: this.apiParams.customerType,
        departmentId: this.apiParams.departmentId,
        partnerPaymentStatus: this.apiParams.partnerPaymentStatus,
      };
    },
    getValuesMultiSelect(arr, prop) {
      return arr.reduce((accumulator, currentValue) => {
        if (currentValue.checked) accumulator.push(currentValue[prop]);
        return accumulator;
      }, []);
    },
    onSelected(option, type, value) {
      switch (type) {
        case 'Status':
          this.checkedOptions(this.optionStatus, option, 'value', value);
          break;
        case 'LoanStatus':
          this.checkedOptions(this.optionLoanStatus, option, 'value', value);
          break;
        case 'Employee':
          this.apiParams.employeeId = option.item.id;
          break;
        case 'OrderSource':
          this.apiParams.orderSourceId = option.item.id;
          break;
        default:
          break;
      }
    },
    checkedOptions(items, option, prop, value) {
      const index = items.findIndex((item) => item[prop] === option[prop]);
      if (index > -1) {
        items[index].checked = value;
      }
    },
    onInputed(textInput = '', type) {
      switch (type) {
        case 'OrderSource':
          this.apiParams.orderSourceId = null;
          this.filteredOrderSources = this.fitlerOptionsBy(
            this.optionOrigin.orderSources,
            textInput,
            'name',
            10,
          );
          if (this.filteredOrderSources.length === 1) {
            this.apiParams.orderSourceId = this.filteredOrderSources[0].id;
          }
          break;
        case 'Employee':
          this.apiParams.employeeId = null;
          this.filteredEmployees = this.fitlerOptionsBy(
            this.optionOrigin.employees,
            textInput,
            'fullName',
            10,
          );
          if (this.filteredEmployees.length === 1) {
            this.apiParams.employeeId = this.filteredEmployees[0].id;
          }
          break;
        default:
          break;
      }
    },
    fitlerOptionsBy(items, textInput, prop, limit) {
      return cloneDeep(items)
        .filter((item) => {
          if (item) {
            const nameWTUnicode = removeAccents(item[prop] || '');
            const nameInputWTUnicode = removeAccents(textInput);
            const index = nameWTUnicode
              .toLowerCase()
              .indexOf(nameInputWTUnicode.toLowerCase());

            if (index > -1) {
              return true;
            }
          }
          return false;
        })
        .slice(0, limit);
    },
    onCheckBoxOrders(orders, type) {
      this.selectedOrders = orders;
      this.type = type;
    },
    onSetMode(mode) {
      this.mode = mode;
    },
    onRefreshOrder(check) {
      if (check) {
        this.selectedOrders = [];
        this.fetchDataTable();
      }
      this.$bvModal.hide('md-change-status');
    },
    refreshSelectedOrder(id) {
      const index = this.orders.findIndex((order) => order.id === id);
      if (index > -1) {
        this.orders[index].selected = false;
      }
    },
    fetchOrderSources: function () {
      ApiService.query(`orderSources/getAll`).then((response) => {
        if (response.data.status) {
          const orderSources = response.data.data;
          this.filteredOrderSources = orderSources;
          this.optionOrigin.orderSources = orderSources;
        }
      });
    },
    fetchStores: function () {
      // ApiService.query('stores/getStores').then((response) => {
      //   if (response.data.status) {
      //     const stores = response.data.data;
      //     this.optionStores = stores;
      //     this.optionOrigin.stores = stores;
      //   }
      // });
      ApiService.get(`stores/get-by-user`).then(({ data }) => {
        if (data.status === 1) {
          const stores = data.data.stores;
          this.optionStores = stores.map((item) => {
            return {
              id: item.id,
              suggestionName: item.name,
              name: item.name,
            };
          });
          this.optionOrigin.stores = stores;
          if (stores.length === 1) {
            this.apiParams.storeIds.push(this.optionStores[0]);
            const index = this.optionStores.findIndex(
              (item) => item.id == stores[0]['id'],
            );
            this.optionStores[index].checked = true;
            // console.log(index);
          }
          // if (stores.length === 1 && !this.storeId) {
          //   this.form.storeId = stores[0].id;
          //   this.form.selectedStore = stores[0].name;
          //   this.getListEmployeeByStore();
          // } else {
          //   this.filteredStoreOptions = [...this.storeOptions];
          // }
          this.onFilter();
        }
      });
    },
    fetchEmployees: function () {
      const storeIds = [
        ...new Set(this.apiParams.storeIds.map((item) => item.id)),
      ];
      ApiService.get(`users/get-by-list-store?storeIds=${storeIds}`).then(
        (response) => {
          if (response.data.status) {
            const employees = response.data.data;
            this.filteredEmployees = employees;
            this.optionOrigin.employees = employees;
          }
        },
      );
    },
    updateCompanyComponent(companyId) {
      this.apiParams.companyId = companyId;
    },
    onChangeCustomerPhone(textInput) {
      const searchText = textInput ? textInput.trim() : null;
      this.apiParams.customerPhoneSearch = searchText;
      this.debounceSearchCustomerPhone();
    },
    debounceSearchCustomerPhone: decounce(function () {
      if (!this.isSearchingCustomerPhone) {
        this.getListCustomer();
      }
    }, TIME_TRIGGER),
    getListCustomer() {
      const searchText = (this.apiParams.customerPhoneSearch || '').trim();
      if (!searchText) {
        this.filteredOptionsCustomerPhone = [];
        return;
      }
      this.isSearchingCustomerPhone = true;
      this.filteredOptionsCustomerPhone = [];

      // Gõ toàn số → gợi ý theo SĐT (prefix); có chữ → gợi ý theo tên (fullName LIKE).
      const isPhone = /^\d+$/.test(searchText);
      const param = isPhone
        ? `customerPhone=${encodeURIComponent(searchText)}`
        : `customerName=${encodeURIComponent(searchText)}`;

      ApiService.get(`customers?${param}&page=1&limit=20`).then(({ data }) => {
        const customers = data.data.data;
        this.filteredOptionsCustomerPhone = customers || [];
        this.isSearchingCustomerPhone = false;
      });
    },
    onSelectedCustomerPhone(option) {
      if (!option) return;
      this.apiParams.customerPhoneSearch = option.item.phoneNumber;
    },
    getSuggestionCustomerPhoneValue(suggestion) {
      return suggestion.item.phoneNumber;
    },
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return this.layoutConfig('loader.logo');
    },
    optionOrderSources() {
      return cloneDeep(this.filteredOrderSources);
    },
    optionsEmployee() {
      return cloneDeep(this.filteredEmployees);
    },
    optionsCustomerPhone() {
      return cloneDeep(this.filteredOptionsCustomerPhone);
    },
    checkJobTitle() {
      return {
        isCR: (jobTitleId) => {
          return JOB_TITLE_ORDER.CR.includes(jobTitleId);
        },
        isShop: (jobTitleId) => {
          return JOB_TITLE_ORDER.SHOP.includes(jobTitleId);
        },
        isDP: (jobTitleId) => {
          return JOB_TITLE_ORDER.DP.includes(jobTitleId);
        },
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
.contract-page {
  .checkbox-style {
    position: absolute;
    right: 0.7vw;
  }

  .custom-card-body {
    padding: 0 2.25rem;
  }

  .date-style {
    display: flex;
    align-items: center;
  }

  .select-style {
    border-radius: 0.28rem;
    box-shadow: none;
    border: 1px solid #ced4da;
  }

  input.form-control {
    border: 1px solid #ced4da;
  }

  .multiselect__tags {
    height: calc(1.35em + 1.1rem + 2px);
    display: block;
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    font-size: 0.925rem;
    min-height: initial;
    padding-top: 0.3rem;
  }

  .multiselect__select {
    width: 3rem;
    height: 2.5rem;
    top: 0.1rem;
  }

  .multiselect__placeholder {
    color: #495057;
    padding-left: 0.2rem;
  }

  .multiselect__element {
    font-size: 0.925rem;
  }

  .multiselect__input {
    padding-top: 0.2rem;
    font-size: 0.925rem;
  }

  .multiselect__single {
    font-size: 0.925rem;
    line-height: 1.9;
    padding-left: 0.2rem;
    display: inline-block;
    max-width: 100%;
  }

  .autosuggest__results {
    position: absolute;
    width: 100%;
    max-height: 200px;
    z-index: 999;
    border: 1px solid #e0e0e0;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
  }

  .autosuggest__results-container {
    position: relative;
    width: 100%;
  }

  .autosuggest__input {
    display: block;
    width: 100%;
    height: calc(1.35em + 1.1rem + 2px);
    line-height: 1.35;
    padding: 0.55rem 0.75rem;
    font-weight: 400;
    font-size: 0.925rem;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.28rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .autosuggest__input:focus {
    outline: none !important;
    border: 1px solid #92c5f9;
  }

  .autosuggest__results-item:hover {
    background-color: #ddd;
  }

  .autosuggest__results ul li {
    padding: 8px;
  }
  #autosuggest {
    width: 100%;
  }

  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(11% - 0.25rem);
    background-color: #f0f1f9;
  }

  .wizard.wizard-4
    .wizard-nav
    .wizard-steps
    .wizard-step[data-wizard-state='current'] {
    background-color: #ffffff;
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .collapsing {
    -webkit-transition: none;
    transition: none;
    display: none;
  }
  .togge-filter {
    background-color: #3d8cdd;
    border-color: #3d8cdd;
  }

  .vue-treeselect__input-container {
    padding-top: 0px;
  }

  .vue-treeselect__control {
    border-radius: 0.28rem;
    border: 1px solid #ced4da;
    height: 2.5rem;
  }
}
</style>
<style lang="scss" scoped>
// ===== Dashboard stats cards — palette KTUI (đồng bộ trang Đề nghị tạo HĐ) =====
$ctr-border: #ebedf3;

// Icon nút Xuất Excel phải kế thừa màu của nút (outline-success → xanh, hover → trắng).
.contract-page {
  // Lưới tự co — 7 ô phân bố đều theo bề rộng, không để slot trống lệch hàng.
  .ctr-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(142px, 1fr));
    gap: 8px;
    margin-bottom: 14px;

    @media (max-width: 575.98px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  // Đường kẻ ngăn dashboard ↔ các ô filter chi tiết bên dưới.
  .ctr-divider {
    height: 1px;
    background: $ctr-border;
    margin: 0 0 18px;
  }
  .ctr-stat-card {
    --ctr-accent: #464e5f;
    --ctr-accent-soft: #ecf0f3;
    background: #fff;
    border: 1px solid $ctr-border;
    border-radius: 9px;
    padding: 8px 11px;
    display: flex;
    align-items: center;
    gap: 9px;
    cursor: pointer;
    user-select: none;
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease,
      transform 0.15s ease,
      background-color 0.15s ease;

    &:hover {
      border-color: #c9cfe0;
      box-shadow: 0 4px 12px rgba(58, 65, 111, 0.08);
      transform: translateY(-1px);
    }
    // Ô đang được chọn → viền + nền theo đúng màu của trạng thái đó.
    &.active {
      border-color: var(--ctr-accent);
      box-shadow: inset 0 0 0 1px var(--ctr-accent);
      background: var(--ctr-accent-soft);
    }
  }
  // Badge số đếm — bo tròn, nền nhạt + chữ đậm theo màu trạng thái.
  .ctr-stat-num {
    min-width: 34px;
    height: 34px;
    padding: 0 9px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: -0.3px;
    flex-shrink: 0;
    background: var(--ctr-accent-soft);
    color: var(--ctr-accent);
  }
  .ctr-stat-label {
    font-size: 11.5px;
    font-weight: 600;
    color: #5e6278;
    line-height: 1.25;
  }
}
</style>
